<div class="pending-checklists-wrapper">
  <div class="d-flex title-container">
    <div class="title">{{ (paramsChecklistStatus === 'ALL' ? 'deliveryChecklist.searchResults' : paramsChecklistStatus
      === Status.PENDING ? 'deliveryChecklist.pendingDeliveryChecklists' : paramsChecklistStatus === Status.COMPLETED ?
      'deliveryChecklist.completedDeliveryChecklists' :
      'deliveryChecklist.deliveryChecklists') | translate}} <span *ngIf="(totalCount$ | async) > 0">({{totalCount$ |
        async }}<span *ngIf="isChecklistsSearch && leftMenuCount>0">/{{leftMenuCount}}</span>)</span></div>
    <div class='create-button' (click)="createNewDeliveryChecklist()">
      <div class='action enabled'>
        <div class="box">
          <div class="plus">+</div>
        </div>
        <div class="btnText">{{ 'deliveryChecklist.createNewDeliveryChecklist' | translate }}</div>
      </div>
    </div>
  </div>

  <app-spinner *ngIf="showSpinner"></app-spinner>

  <section *ngIf="!(isLoading$ | async); else loader">
    <div class="sub-header">
      <div class="d-flex" style="  width: 12%; float: right;">
        <div class="records-per-page">{{ 'vehicleManagement.recordsPerPage' | translate }}</div>
        <mat-select style="width: 45%" [(ngModel)]="PAGE_SIZE">
          <mat-option [value]='option' *ngFor="let option of pageSizeOptions"
            (click)="onRecordsPerPageChange(option)">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="no-checklist"
      *ngIf="!(checklists?.length > 0) && searchValues.length === 0 && !isSearchLoading;else default">
      <mat-icon class="mat-icon">info_outline</mat-icon>
      <span class="label">{{ 'deliveryChecklist.noDeliveryChecklist' | translate}}</span>
    </div>
    <ng-template #default>
      <div class="no-checklist" *ngIf="!(checklists?.length > 0) && searchValues.length === 0 && !isSearchLoading">
        <mat-icon class="mat-icon">info_outline</mat-icon>
        <span class="label">{{ 'deliveryChecklist.noDeliveryChecklist' | translate}}</span>
      </div>
    </ng-template>
    <div *ngIf="searchValues.length > 0" class="search-group d-flex">
      <div class="d-flex filter-group">
        <div *ngFor="let search of searchValues, let i = index" class="filter-list">
          <div class="filter-value d-flex" *ngIf="search.colValue">
            <div class="filter-text">

              <span>{{search.colValue | translate}}</span>

            </div>

            <div class="icon" (click)="onCloseFilterValue(search.column, i)">
              <mat-icon class="clear-icon">clear</mat-icon>
            </div>

          </div>
        </div>
      </div>
      <div class="arrow-button" (click)="scrollUp()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </div>

      <div class="arrow-button" (click)="scrollDown()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>
      <div class="d-flex" style="width: 3%">
        <div (click)="clearFilters()" class='action enabled clear-btn-style'>
          <div class="btnText clear-btn-text">{{ 'servicePersonnel.clear' | translate }}</div>
        </div>
      </div>
    </div>
    <div [hidden]="!(checklists?.length > 0) && searchValues.length === 0 && !isSearchLoading">
      <div class="panel-left" tabindex="0" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
        <div style="width: 100%">
          <div class="table-responsive checklist-tbl" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
            <div #dragHelper class="grid-helper"></div>
            <table #checklistGrid id="checklist-grid" mat-table [dataSource]="dataSource" multiTemplateDataRows
              class="table alternateColor">
              <caption style="display: none;"> </caption>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef aria-label="row actions" scope="col">
                </th>
                <td mat-cell *matCellDef="let element">
                  <span>
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" #actionMenuTrigger="matMenuTrigger" aria-label="More actions"
                      style="padding: 0px; height: 20px; width: 20px;">
                      <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-menu #actionMenu="matMenu" class="custom-checklist-summary-menu1">
                      <button mat-menu-item *ngIf="element.status === Status.PENDING"
                        (click)="editAppointment(element)">
                        <div class="action-btn action-icon action-btn-edit"></div>
                        {{ 'pendingAppointments.complete/Edit' | translate }}
                      </button>
                      <button mat-menu-item
                        *ngIf="element.status === Status.PENDING && element.status !== Status.VEHICLE_RETURNED"
                        (click)="cancelCheckListAppointment($event, element)">
                        <div class="action-btn action-icon action-btn-cancel"></div>
                        {{ 'deliveryChecklist.cancel' | translate }}
                      </button>
                      <button mat-menu-item *ngIf="element.status === Status.SUBMITTED"
                        (click)="resubmitChecklist(element)">
                        <div class="action-btn action-icon action-btn-resubmit"></div>
                        {{ 'deliveryChecklist.resubmit' | translate }}
                      </button>
                      <button mat-menu-item
                        *ngIf="element.status === Status.COMPLETED || element.status === Status.VEHICLE_RETURNED"
                        (click)="viewPrintPdf(element)">
                        <div class="action-btn action-icon action-btn-view"></div>
                        {{ 'deliveryChecklist.view' | translate }}
                      </button>
                      <button mat-menu-item *ngIf="element.status === Status.COMPLETED"
                        (click)="viewPrintPdf(element, true)">
                        <div class="action-btn action-icon action-btn-print"></div>
                        {{ 'deliveryChecklist.print' | translate }}
                      </button>
                      <button mat-menu-item *ngIf="element.status === Status.COMPLETED" (click)="downloadPDF(element)">
                        <div class="action-btn action-icon action-btn-download"></div>
                        {{ 'deliveryChecklist.download' | translate }}
                      </button>
                      <button mat-menu-item
                        *ngIf="element.status === Status.COMPLETED"
                        (click)="sendEmailToCustomer($event, element, actionMenuTrigger)">
                        <div class="action-btn action-icon action-btn-email"></div>
                        {{ 'deliveryChecklist.email' | translate }}
                      </button>
                    </mat-menu>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef aria-label="row actions" scope="col">
                </th>
                <td mat-cell *matCellDef="let element">
                  <span>
                    <mat-checkbox (click)="$event.stopPropagation()">
                    </mat-checkbox>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumns">
                <th mat-header-cell *matHeaderCellDef scope="col" #tableHead>
                  <div class="d-flex" [title]="column.display | translate" *ngIf="column.id !== 'actions'"
                    (click)="sortChange(column.id)">
                    <div class="column-name">{{column.display | translate}} </div>
                    <div *ngIf="(column.id === 'customerName' || column.id === 'model' || column.id === 'advisor' || column.id === 'deliveryDate') && sortingField === column.id">
                      <mat-icon class="sort-icon" *ngIf="sortOrder === 'asc' "
                        [title]="('pendingAppointments.ascending' | translate)">arrow_downward</mat-icon>
                      <mat-icon class="sort-icon" *ngIf="sortOrder === 'desc' "
                        [title]="('pendingAppointments.descending' | translate)">arrow_upward</mat-icon>
                    </div>
                  </div>
                  <div class="d-flex column-name" [title]="column.display | translate" *ngIf="column.id === 'actions'">
                    {{column.display | translate}}
                  </div>
                  <span class="tm-column-resize" (dblclick)="toggleColumnWidth(column.display,$event)" cdkDrag
                    cdkDragLockAxis="x" (click)="onDraggerClick($event)"
                    (cdkDragStarted)="startResize($event,column.display)"
                    (cdkDragMoved)="resizeColumn($event, column.display)"
                    (cdkDragEnded)="endResize($event, column.display)"></span>
                </th>
                <td mat-cell *matCellDef="let element">



                  <span *ngIf="column.id === 'customerName'">
                    <span
                      title="{{element.customer.firstName}} {{element.customer.lastName}}">{{element.customer.firstName}}
                      {{element.customer.lastName}}</span>
                  </span>

                  <span *ngIf="column.id === 'contactInfo'">
                    <span
                      title="{{element.customer.emailAddress ? element.customer.emailAddress : (element.customer.phoneNumber ? element.customer.phoneNumber : '')}}">{{element.customer.emailAddress
                      ? element.customer.emailAddress : element.customer.phoneNumber}}</span>
                  </span>

                  <span *ngIf="column.id === 'model' || column.id === 'dealer' "
                    [title]="element.vehicle[column.col] ? element.vehicle[column.col] : 'NA'">
                    {{element.vehicle[column.col] ? element.vehicle[column.col] : 'NA'}}</span>

                  <span *ngIf="column.id === 'status' "
                    [title]="(element[column.col] ? (element[column.col] === Status.COMPLETED ? 'deliveryChecklist.completed' : element[column.col] === Status.PENDING ? 'deliveryChecklist.pending' : element[column.col] === Status.SUBMITTED ? 'deliveryChecklist.submitted' : element[column.col] === Status.VEHICLE_RETURNED ? 'deliveryChecklist.vehicle_returned': element[column.col] )  : 'NA') | translate">
                    {{(element[column.col] ? (element[column.col] === Status.COMPLETED ? 'deliveryChecklist.completed' :
                    element[column.col] === Status.PENDING ? 'deliveryChecklist.pending' : element[column.col] ===
                    Status.SUBMITTED ? 'deliveryChecklist.submitted' : element[column.col] === Status.VEHICLE_RETURNED ?
                    'deliveryChecklist.vehicle_returned': element[column.col] ) : 'NA') | translate}} </span>

                  <span *ngIf="(column.id === 'advisor' && element[column.col]) || column.id === 'deliveryTime' ">
                    <span title="{{element[column.col]}}">{{element[column.col]}}</span>
                  </span>
                  <span *ngIf="column.id === 'vehicleStatus'">
                    <span title="{{element.vehicle[column.col]}}">{{element.vehicle[column.col]}}</span>
                  </span>

                  <span *ngIf="column.id === 'vin'" style="display: flex;"
                    [title]="element.vehicle[column.col] ? element.vehicle[column.col] : 'NA'">
                    <div style="max-width: 12px;">
                      <span *ngIf="width  >= 113 && width < 120">...{{element.vehicle[column.col].slice(-8)}}</span>
                      <span
                        *ngIf="width >= 120 && width < 165">...{{element.vehicle[column.col].slice(splitChar)}}</span>
                      <span *ngIf="width >= 165"> {{element.vehicle[column.col]}}</span>
                    </div>
                    <div style="margin-left: auto;">
                      <span class="copy-vin">
                        <button mat-icon-button aria-label="icon-button with a menu" class="copy-icon"
                          matTooltipPosition="above" [matTooltip]="'vehicleManagement.copyVin' | translate"
                          (click)="onCopyDetails(element.vehicle['vin'])">
                          <mat-icon>
                            <span class="material-icons">content_copy</span>
                          </mat-icon>
                        </button>
                      </span>
                    </div>
                  </span>

                  <span *ngIf="column.id === 'deliveryDate' "
                    [title]="element[column.col] ? getDeliveryDate(element[column.col]) : ''">
                    {{element[column.col] ? getDeliveryDate(element[column.col]) : ''}} </span>



                </td>
              </ng-container>

              <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumnsForFilter">
                <div>
                  <th mat-header-cell *matHeaderCellDef scope="col" class="filter-header">

                    <form [formGroup]="searchForm">

                      <div *ngIf="column.id === 'selectFilter' ">
                        <mat-icon class="search-icon">search</mat-icon>
                      </div>

                      <div style="margin-top: 0.5rem"
                        *ngIf="column.id !== 'selectFilter' && column.id !== 'actionsFilter' && column.id !== 'statusFilter'  && column.id !== 'deliveryTimeFilter'">
                        <input matInput [formControlName]="column.id" #searchValue autocomplete="off"
                          [ngClass]=" searchValue.value ? 'opacity-1' : 'opacity-0'"
                          placeholder="{{column.display | translate}}"
                          (keyup.enter)="addSearchField(column.id, searchValue.value)"
                          (keydown.tab)="addSearchField(column.id, searchValue.value)">
                      </div>

                      <div *ngIf="column.id === 'statusFilter'">
                        <mat-select [formControlName]="column.id">
                          <mat-option [value]='option.id' *ngFor="let option of statusOptions"
                            (click)="addSearchField(column.id,option.display)">
                            {{ option.display | translate }}
                          </mat-option>
                        </mat-select>
                      </div>

                    </form>
                  </th>
                </div>
              </ng-container>

              <ng-container matColumnDef="noRecord">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length" class="text-center">
                  <div style="margin-top: 5rem;">
                    <mat-icon class="mat-icon no-record-icon">info_outline</mat-icon>
                  </div>
                  <div class="no-record-label">{{'vehicleManagement.noMatchFound' | translate}}</div>
                  <div (click)="clearFilters()" class='action enabled no-record-clear-btn'>
                    <div class="btnText no-record-clear-btn-text">{{'vehicleManagement.clearFilters' | translate}}</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="searchLoader">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length" class="text-center">
                  <div id="search-checklist-loading">
                    <app-loading size="0.8" color="var(--primary-sec-color)" loadingSymbol="dots"
                      [text]="'serviceSchedule.loading' | translate">
                    </app-loading>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"
                [class.no-record-header]="dataSource.data.length === 0"></tr>

              <tr mat-header-row *matHeaderRowDef="columnsToDisplayForFilter; sticky: true" class="filter-row"></tr>


              <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
              </tr>

              <tr mat-footer-row *matFooterRowDef="['searchLoader']" class="search-loader"
                [class.no-row]="!isSearchLoading"></tr>

              <tr mat-footer-row *matFooterRowDef="['noRecord']"
                [ngClass]="(dataSource.data.length === 0) && (searchValues.length > 0 && !isSearchLoading) ? 'no-record-row' : 'no-row'">
              </tr>

            </table>
          </div>
          <mat-paginator *ngIf="checklists?.length > 0 && (totalCount$ | async) > 0 && !isSearchLoading" #paginator [pageSizeOptions]="[5, 10, 20]" hidePageSize="true"
            showFirstLastButtons (page)="onPageChange($event)" [length]="totalCount$ | async"
            [pageIndex]="pageIndex" [pageSize]="PAGE_SIZE" aria-label="Select page of periodic elements">
          </mat-paginator>
        </div>

      </div>
    </div>
  </section>

  <ng-template #loader>
    <div id="loading-spinner">
      <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
    </div>
  </ng-template>
</div>